import * as React from 'react'
import { UploadedFilesMainConnected } from './UploadedFilesMainConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const UploadedFilesMainExamples = () => {
  return (
    <div className="UploadedFilesMainExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <UploadedFilesMainConnected />
      </Provider>
    </div>
  )
}
